import info from 'virtual:build-info';
import { Card } from '../card';
import MoreIcon from '../../images/more.svg?react';
import styles from './index.module.scss';

const About = () => {
  const data = [
    {
      title: 'Repos',
      data: [
        {
          key: '1',
          title: 'Version',
          extra: (
            <div className={styles.extra}>
              <a
                style={{ color: '#703EFF' }}
                href="https://halochat.io"
                target="_blank"
                rel="noreferrer"
              >
                {info.version}
              </a>
              <MoreIcon />
            </div>
          ),
        },
        {
          key: '2',
          title: 'Website',
          extra: (
            <div className={styles.extra}>
              <a href="https://halochat.io" target="_blank" rel="noreferrer">
                https://halochat.io
              </a>
              <MoreIcon />
            </div>
          ),
        },
      ],
    },
    {
      title: 'Documents',
      data: [
        {
          key: '1',
          title: 'User Agreement',
          extra: <MoreIcon />,
          onClick: () => {
            window.open('https://halochat.io/terms', '_blank');
          },
        },
        {
          key: '2',
          title: 'Privacy Policy',
          extra: <MoreIcon />,
          onClick: () => {
            window.open('https://halochat.io/privacy', '_blank');
          },
        },
      ],
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.title}>About HaloChat</div>
      <div className={styles.content}>
        {data.map((item, index) => {
          return (
            <Card
              className={styles.card}
              key={index}
              title={item.title}
              data={item.data}
            ></Card>
          );
        })}
      </div>
    </div>
  );
};
export default About;
